






import Vue, { VueConstructor } from 'vue';
import { mapGetters, mapState } from 'vuex';

import LocationService from '@/services/LocationService';

interface VuexBindings {
	isLoading: boolean;
	location: Locations.Location;
}

export default (Vue as VueConstructor<Vue & VuexBindings>).extend({
	name: 'LoginMarketing',
	props: {
		loginMarketing: String,
	},
	data() {
		return {
			marketing: '' as string,
		};
	},
	computed: {
		...mapState(['isLoading']),
		...mapGetters('location', ['location']),

		currentMarketing(): string {
			return this.loginMarketing || this.marketing;
		},
	},
	methods: {
		created() {
			this.loadMarketing();
		},
		async loadMarketing() {
			this.marketing = await LocationService.fetchTerms({
				location: this.location.codeID as string,
			});
		},
	},
});
